
import { Props, Args, Payload } from './types'
import { axiosInstance } from '@/lib/axios'

export function getQuarterExchangeRateStatus({
  companyId,
  ...params
}: Props & Args) {
  return axiosInstance.get<Payload>(
    `/api/${companyId}/timesheet/quarterExchangeRateStatus`,
    {
      params,
    },
  )
}
